import React from 'react';
import { MessagePropertiesContext } from '../../../contexts/messageProperties';
import Modal from '../../../components/modal/rightSlideInModal';

const deliveryInformationContent = document.getElementById('cms-delivery-information')?.innerHTML || '';

function DeliveryInformationModal(): React.ReactElement {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [formattedMessage] = React.useContext(MessagePropertiesContext);
  const heading = formattedMessage({
    id: 'product.section.deliveryInformationModal.heading',
    fallback: 'Delivery Information'
  });

  const handleClose = (): void => setIsModalOpen(false);
  const handleOpen = (): void => setIsModalOpen(true);

  return (
    <Modal onOpen={handleOpen} isOpen={isModalOpen} onClose={handleClose} heading={heading}>
      <div dangerouslySetInnerHTML={{ __html: deliveryInformationContent }} />
    </Modal>
  );
}

export default DeliveryInformationModal;
